import React, {useContext} from "react";
import {FaSignOutAlt} from "react-icons/fa";
import AuthContext from "../Common/AuthContext"; // Assuming you have AuthContext

const Header = () => {
    const authCtx = useContext(AuthContext);// Get logout function

    const logout = () => {
        authCtx.logout();
        window.location.href = "/login";
    }

    return (
        <div className="bg-teal-500 shadow-md">
            <nav className="container mx-auto flex items-center justify-between py-1 px-6">
                {/* Brand with Icon */}
                <a href="/" className="flex items-center text-white text-lg font-semibold">
                    <img width="80px" src="/img/logo.jpeg"/>
                </a>

                {authCtx.id &&
                    <div className="flex items-center space-x-6">
                        {/*/!* Profile Link *!/*/}
                        {/*<a href="/profile" className="flex items-center text-white hover:text-gray-200">*/}
                        {/*    <FaUser className="mr-1" />*/}
                        {/*    <span>Profile</span>*/}
                        {/*</a>*/}

                        {/* Logout Button */}
                        <button
                            onClick={logout}
                            className="flex items-center bg-red-600 text-white px-4 py-2 rounded-lg shadow hover:bg-red-700 transition"
                        >
                            <FaSignOutAlt className="mr-2" />
                            <span>Logout</span>
                        </button>
                    </div>
                }

            </nav>
        </div>
    );
};

export default Header;
